import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";
import {
  AppNavbarBrand,
  AppSidebarToggler,
} from "@coreui/react";
import { Nav, Label } from "reactstrap";
import styled from "styled-components";
import delsat from "../../assets/img/brand/delsat.png";

const RightIcon = styled.i`
  color: #fff;
  margin-left: -20px;
  margin-right: 20px;
`;

const DefaultHeader = () => {
  const history = useHistory();

  const handleOnIconClick = () => {
    history.push("/dashboard");
  };

  const handleAsideToggle = () => {
    const layout = document.getElementsByClassName("header-fixed")[0];
    if (!layout) return;

    const isOpen =
      layout.classList.contains("aside-menu-lg-show") ||
      layout.classList.contains("aside-menu-show");

    layout.classList.remove("aside-menu-show");
    layout.classList.toggle("aside-menu-lg-show", !isOpen);
  };

  return (
    <div>
      <AppSidebarToggler
        className="d-lg-none"
        display="xs"
        mobile
        style={{ marginLeft: "10px" }}
      />

      <AppNavbarBrand
        full={{ src: delsat, width: 89, height: 20 }}
        onClick={handleOnIconClick}
        className="c-p"
      />

      <AppSidebarToggler className="d-md-down-none" display="lg"/>

      <Nav className="ml-auto" navbar />

      <button
        type="button"
        id="button-nav-right"
        className="navbar-toggler d-xs-down-none"
        aria-label="Abrir o cerrar navegador de entidades"
        title="Entidades"
        onClick={handleAsideToggle}
      >
        <RightIcon className="cui-sort-ascending icons font-2xl d-block" />
      </button>
    </div>
  );
};

export default DefaultHeader;
